import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { _delete } from "../../Api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import _ from "lodash";

export default function RemoveSubscriptionDialog(props) {
  const closeDialog = () => props.setDialogType(null);
  const merchantId = useParams().merchantId;

  const remove = () => {
    _delete("/nova/merchant/" + merchantId + "/subscription/" + props.selectedSubscription)
      .then(() => {
        toast.success(props.dialogType.toUpperCase() + " subscription successfully removed!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        const index = props.subscriptions.findIndex((sub) => sub.id === props.selectedSubscription);
        props.subscriptions.splice(index, 1);
        props.setSubscriptions(_.cloneDeep(props.subscriptions));
        closeDialog();
      })
      .catch((error) => {
        toast.error(props.dialogType + " subscription could not be removed.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.error(error);
        closeDialog();
        return Promise.reject(error);
      });
  };

  return (
    <Dialog open={!!props.dialogType}>
      <DialogTitle>Are you sure you want to remove your subscription?</DialogTitle>
      <DialogActions>
        <Button onClick={closeDialog}>Cancel</Button>
        <Button onClick={remove}>Remove</Button>
      </DialogActions>
    </Dialog>
  );
}
